<app-loader
	[enableCircle]="true"
	[isActive]="isLoading.value$ | async"
	[isAfterViewInit]="false"
></app-loader>
<h1 matDialogTitle>
	<div class="flex flex-row items-center justify-start gap-2">
		<div>{{ 'comego.fixRulbreak' | translate }}</div>
		<div class="flex-auto"></div>
	</div>
</h1>

<mat-dialog-content
	cdkTrapFocus
	class="!overflow-y-auto !max-h-[calc(100vh-200px)]"
>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.group"
		*ngIf="this.group as grp"
		class="flex flex-col"
	>
		<div class="flex flex-row gap-2">
			<div class="flex flex-auto flex-col items-stretch justify-start gap-2 lg:wflex-[1_0_440px]">
				<ng-container *ngIf="{ shown: isFieldShown('user') } as ctrl">
					<div
						(click)="$event.preventDefault(); group.controls.user.enabled && !hasActiveRecording && openUserPicker()"
						[ngClass]="{ 'cursor-pointer': group.controls.user.enabled && !hasActiveRecording }"
						*ngIf="ctrl.shown && (workspace$canManageOthers.value$ | async)"
						class="flex w-full flex-col"
					>
						<mat-form-field
							[ngClass]="{ 'opacity-50': hasActiveRecording }"
							appearance="standard"
							class="user-picker-item form-control-interactive mat-form-field-no-label"
						>
							<div
								*ngIf="groupValue.user as user"
								class="-mb-16px flex items-center space-x-1.5"
							>
								<app-user-avatar
									[userId]="user.id"
									class="rounded-full"
									size="40px"
								></app-user-avatar>
								<div class="flex flex-auto flex-col leading-none pl-1">
									<span>{{ user.name }}</span>
								</div>
								<button
									(click)="$event.preventDefault(); $event.stopPropagation(); patchValue({ user: null })"
									*ngIf="this.workspace$isAdmin.value && (postDiffUser$ | async) && !hasActiveRecording"
									mat-icon-button
								>
									<mat-icon>clear</mat-icon>
								</button>
							</div>
							<input
								[disabled]="group.controls.user.disabled || hasActiveRecording || !this.workspace$isAdmin.value"
								[value]="groupValue.user"
								class="!pointer-events-none"
								matInput
							>
						</mat-form-field>
					</div>
				</ng-container>
				<ng-container *ngIf="{ shown: isFieldShown('date') } as ctrl">
					<div
						(click)="$event.preventDefault(); group.controls.date.enabled && !hasActiveRecording && openCalPicker()"
						[ngClass]="{ 'cursor-pointer': group.controls.date.enabled && !hasActiveRecording }"
						*ngIf="ctrl.shown"
						class="flex w-full flex-col"
					>
						<mat-form-field
							[ngClass]="{ 'opacity-50': hasActiveRecording }"
							appearance="standard"
							class="comego-date-readonly pointer-events-none"
						>
							<mat-icon
								class="text-muted prefix-icon leading-none"
								matPrefix
								>calendar_month</mat-icon
							>
							<input
								[value]="groupValue.date | formatDate"
								class="!pointer-events-none"
								matInput
								readonly
							>
						</mat-form-field>
					</div>
				</ng-container>
			</div>
		</div>
		<div
			class="mb-3 flex items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 dark:border-blue-400/40 dark:bg-blue-950/30"
			role="status"
		>
			<div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-500 text-white">
				<span font-size="16px"> i</span>
			</div>
			<div class="flex min-w-0 flex-col gap-0.5">
				<span class="text-base font-semibold leading-snug text-blue-700 dark:text-blue-300">
					{{ 'comego.ruleViolationInfoTitle' | translate }}
				</span>
				<span class="text-sm leading-snug text-blue-900/80 dark:text-blue-100/80">
					{{ 'comego.ruleViolationInfoDescription' | translate }}
				</span>
			</div>
		</div>
		@if (violationNotices.length) {
		<div class="mb-3 flex flex-col gap-2">
			@for (notice of violationNotices; track $index) {
			<div class="alert alert-danger alert-tight rounded py-2">
				@if (notice.start && notice.end) {
				{{ 'comego.ruleViolationEntryNotice' | translate: { start: notice.start, end: notice.end } }}
				{{ notice.message | translate: (notice.args || {} | translateArgs) }}
				} @else {
				{{ notice.message | translate: (notice.args || {} | translateArgs) }}
				}
			</div>
			}
		</div>
		}
		<div class="mat-bd-5 -mx-2 flex flex-col rounded-lg px-4 pt-3 pb-3">
			<div class="xs:mb-4 mb-0 flex">
				<div class="flex flex-grow flex-col">
					<div class="flex flex-col">
						<ng-container *ngIf="duration$ | async as dur">
							<div class="flex flex-col space-y-0.5">
								<span class="text-muted mat-typography">
									{{ 'comego.types.work' | translate }}:
									{{ dur.working | parseMsAsDuration: false }}</span
								>
								@if(dur?.absence) {
								<span class="text-muted mat-typography">
									{{ 'comego.types.absence' | translate }}:
									{{ dur.absence | parseMsAsDuration: false }}</span
								>
								}
								<span
									[matTooltip]="(dur.pause - dur.realBreak) > 0
												? ('comego.breakQualifyAs' | translate: {
											shortBreak: dur.realBreak | parseMsAsDuration,
											break: dur.pause | parseMsAsDuration
											}) : null"
									class="text-muted mat-typography"
								>
									{{ 'comego.types.pause_short' | translate }}:
									{{ dur.pause | parseMsAsDuration: false }}
								</span>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="flex flex-row items-center gap-2">
					<button
						(click)="this.comegoDescriptionToggle$.update(!this.comegoDescriptionToggle$.value)"
						[matTooltip]="'comego.toggleDescription' | translate"
						class="!h-6 !w-6 !flex !items-center !justify-center"
						mat-icon-button
						type="button"
					>
						<mat-icon class="!leading-none">{{
							this.comegoDescriptionToggle$.value ? 'comment' : 'comments_disabled'
						}}</mat-icon>
					</button>
				</div>
			</div>
			<div
				*ngIf="{ times: getErrorObservable('times') | async } as error"
				class="flex flex-col xs:mt-2 mt-0 gap-2"
			>
				<ng-container
					*ngFor="let comegoGroup of group.controls.times.controls; let ctrlIndex = index; trackBy: ctrlIndex"
				>
					<div class="flex flex-col mt-2">
						<form
							(blur)="blurFormSort($event)"
							(submit)="$event.preventDefault()"
							[disabled]="isEntryFormDisabled(comegoGroup)"
							[formGroup]="comegoGroup"
							class="flex flex-row flex-wrap items-start gap-4"
						>
							<!-- Icon (always visible on left) -->
							<div
								[ngClass]="[
									comegoGroup.getRawValue()?.type === 'work'
										? 'border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200'
										: comegoGroup.getRawValue()?.type === 'absence'
											? 'border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100'
											: comegoGroup.getRawValue()?.type === 'pause'
												? 'dark:bg-neutral-600 bg-neutral-600/80'
												: comegoGroup.getRawValue()?.recording
													? 'border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200'
													: 'border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100',
								]"
								*ngIf="calcType(iconMap[comegoGroup.getRawValue()?.type]) as type"
								class="mt-5 flex size-6 shrink-0 items-center justify-center rounded-full p-0 leading-6 text-neutral-100"
							>
								<mat-icon
									class="text-center"
									inline
								>
									{{ type }}
								</mat-icon>
							</div>

							<ng-container *ngIf="{ enabled: enabledTypes.value$ | async } as ctrl">
								<!-- Type selector -->
								<mat-form-field
									[ngClass]="{ 'comego-type-readonly': comegoGroup.controls.type.disabled }"
									appearance="standard"
									class="group min-w-0 flex-1 pt-0.5"
								>
									<mat-label
										class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
										>{{
											'comego.type' | translate
										}}</mat-label
									>
									<mat-select formControlName="type">
										<mat-select-trigger>
											<ng-container [ngSwitch]="comegoGroup.getRawValue()?.type">
												<ng-container *ngSwitchCase="'work'">{{
													'comego.types.work' | translate
												}}</ng-container>
												<ng-container *ngSwitchCase="'pause'">{{
													'comego.types.pause' | translate
												}}</ng-container>
												<ng-container *ngSwitchCase="'absence'">{{
													'comego.types.absence' | translate
												}}</ng-container>
												<ng-container *ngSwitchDefault>
													<ng-container *ngFor="let sub of absenceSubcategories">
														<ng-container
															*ngIf="sub.id === comegoGroup.getRawValue()?.type"
															>{{
																sub | absenceTranslate
															}}</ng-container
														>
													</ng-container>
												</ng-container>
											</ng-container>
										</mat-select-trigger>

										<!-- Options -->
										<mat-option
											[disabled]="!ctrl.enabled.work"
											*ngIf="!(isSubAbsence | async)[ctrlIndex]"
											value="work"
										>
											<div class="flex flex-row items-center gap-2">
												<div
													class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200"
												>
													<mat-icon
														class="text-center mr-0"
														inline
														style="margin-right: 0px"
													>
														work_history
													</mat-icon>
												</div>
												<div>{{ 'comego.types.work' | translate }}</div>
											</div>
										</mat-option>
										<mat-option
											[disabled]="!ctrl.enabled.pause"
											*ngIf="!(isSubAbsence | async)[ctrlIndex]"
											value="pause"
										>
											<div class="flex flex-row items-center gap-2">
												<div
													class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 dark:bg-neutral-600 bg-neutral-600/80"
												>
													<mat-icon
														class="text-center mr-0"
														inline
														style="margin-right: 0px"
													>
														pause
													</mat-icon>
												</div>
												<div>{{ 'comego.types.pause' | translate }}</div>
											</div>
										</mat-option>
										<ng-container
											*ngIf="!absenceSubcategories || absenceSubcategories.length === 0"
										>
											<mat-option
												[disabled]="!ctrl.enabled.absence"
												[style.display]="(isSubAbsence | async)[ctrlIndex] ? '' : 'none'"
												value="absence"
											>
												<div class="flex flex-row items-center gap-2">
													<div
														class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100"
													>
														<mat-icon
															class="text-center mr-0"
															inline
															style="margin-right: 0px"
														>
															beach_access
														</mat-icon>
													</div>
													<div>{{ 'comego.types.absence' | translate }}</div>
												</div>
											</mat-option>
										</ng-container>
										<ng-container
											*ngIf="absenceSubcategories?.length && (isSubAbsence | async)[ctrlIndex]"
										>
											<mat-optgroup
												[disabled]="!ctrl.enabled.absence"
												[label]="'workspace.absence-subcategories.title' | translate"
											>
												<mat-option
													[style.display]="absencesForUser(subcategory, groupValue) ? '' : 'none'"
													[value]="subcategory.id"
													*ngFor="let subcategory of absenceSubcategories"
												>
													<div class="flex flex-row items-center gap-2">
														<div
															class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100"
														>
															<mat-icon
																class="text-center mr-0"
																inline
																style="margin-right: 0px"
															>
																beach_access
															</mat-icon>
														</div>
														<div>{{ subcategory | absenceTranslate }}</div>
													</div>
												</mat-option>
											</mat-optgroup>
										</ng-container>
									</mat-select>
								</mat-form-field>

								<!-- Time inputs -->
								<div class="time-inputs-row flex min-w-0 items-center gap-4">
									<div
										[ngClass]="(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]'"
									>
										<app-time-input
											(click)="$event.stopPropagation(); this.selectInput($event, startInpRef)"
											(focus)="this.selectInput($event, startInpRef)"
											(keydown.enter)="$event.preventDefault()"
											[displayFormat]="false"
											[inputPlaceholder]="'timer.time.start' | translate"
											[maxlength]="5"
											#startInpRef="nativeElement"
											#tStartFormField
											elementRef
											formControlName="start"
											matInput
										>
											<ng-template
												let-control="control"
												let-inputPlaceholder="inputPlaceholder"
												timeInputControl
											>
												<mat-form-field
													appearance="standard"
													class="group"
													fxFill
												>
													<mat-label
														class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
														>{{
															inputPlaceholder
														}}</mat-label
													>
													<input
														(blur)="blurFormSort($event, ctrlIndex, 'start')"
														[formControl]="control"
														[placeholder]="inputPlaceholder"
														matInput
														type="text"
													>
												</mat-form-field>
											</ng-template>
										</app-time-input>
									</div>
									<span class="tg-seperator shrink-0 text-center font-bold -mt-3"> - </span>
									@if (comegoGroup.getRawValue()?.recording ) {<ng-container
										*ngTemplateOutlet="recordingText; context: { entry: comegoGroup.getRawValue() }"
									></ng-container
									>} @else {
									<div
										[ngClass]="(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]'"
									>
										<app-time-input
											(click)="$event.stopPropagation(); this.selectInput($event, endInpRef)"
											(focus)="this.selectInput($event, endInpRef)"
											(keydown.enter)="$event.preventDefault()"
											[displayFormat]="false"
											[inputPlaceholder]="'timer.time.end' | translate"
											[maxlength]="5"
											#endInpRef="nativeElement"
											#tEndFormField
											elementRef
											formControlName="end"
											matInput
										>
											<ng-template
												let-control="control"
												let-inputPlaceholder="inputPlaceholder"
												timeInputControl
											>
												<mat-form-field
													appearance="standard"
													class="group"
													fxFill
												>
													<mat-label
														class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
														>{{
															inputPlaceholder
														}}</mat-label
													>
													<input
														(blur)="blurFormSort($event, ctrlIndex, 'end')"
														[formControl]="control"
														[placeholder]="inputPlaceholder"
														matInput
														type="text"
													>
													<mat-hint
														*ngIf="calculateDuration(comegoGroup, ctrlIndex) as duration"
														>{{
															duration | parseMsAsDuration: false
														}}</mat-hint
													>
												</mat-form-field>
											</ng-template>
										</app-time-input>
									</div>
									}
								</div>
							</ng-container>
							<!-- Delete button (hidden when row is not deletable) -->
							@if (!comegoGroup.getRawValue()?.recording) { @if (isItemDeletable(ctrlIndex)) {
							<div class="mt-3 flex shrink-0 opacity-40 group-hover:opacity-100">
								<button
									(click)="deleteItem(ctrlIndex)"
									mat-icon-button
								>
									<mat-icon>cancel</mat-icon>
								</button>
							</div>
							} @else {
							<div class="w-10 shrink-0"></div>
							} } @else {
							<div class="w-10 shrink-0"></div>
							}
						</form>
						@if(error.times?.index === ctrlIndex ) { @if (!error.times?.warning) {
						<div class="text-warn -mt-2 ml-8 text-sm">
							{{ error.times.content | translate: (error.times.args || {} | translateArgs) }}
						</div>
						<div>{{ error.lenght }}</div>
						} @else {
						<div class="-mt-[22px] -mb-2 ml-auto flex flex-shrink-0 sm:mr-[35px] mr-[6%] text-gray-500">
							<mat-icon
								[matTooltip]=" error.times.content | translate: (error.times.args || {} | translateArgs)"
								class="text-lg"
							>
								info
							</mat-icon>
						</div>
						} }
					</div>
				</ng-container>
				<div class="xs:-mt-4 mt-0 flex justify-center">
					<span
						[matTooltip]="(isDailyMaxReachedOrExceededByCombined$ | async) ? ('comego.dailyMaxReachedHint' | translate) : null"
						[matTooltipDisabled]="!(isDailyMaxReachedOrExceededByCombined$ | async)"
						class="inline-flex"
					>
						<button
							(click)="addTime()"
							[disabled]="group.disabled || !(canAddTime.value$ | async) || (isDailyMaxReachedOrExceededByCombined$ | async)"
							color="primary"
							mat-icon-button
						>
							<mat-icon>add</mat-icon>
						</button>
					</span>
				</div>
			</div>
		</div>
	</form>
</mat-dialog-content>
<ng-container
	*ngIf="{
      times: getErrorObservable('times') | async,
      manual: error$.value$ | async,
    } as error"
>
	<div class="inset-x-0 mx-4 my-4">
		<div
			*ngIf="error.manual as err"
			class="alert alert-danger alert-tight rounded py-2"
		>
			{{ err.message | translate: (err.args | translateArgs) }}
		</div>
		<ng-container *ngIf="!error.manual && error.times && error.times.index === undefined && error.times as br">
			<div
				[matTooltip]=" br.content === 'errors.times.comego.breakRuleNotice' ?
			('errors.times.comego.breakRuleDetailed' | translate: (br.args || {} | translateArgs)): null"
				class="alert alert-danger alert-tight rounded py-2"
			>
				{{ br.content | translate: (br.args || {} | translateArgs) }}
			</div>
		</ng-container>
		<div
			*ngIf="scheduleTargetNotice$.value"
			class="alert alert-danger alert-tight rounded py-2 mt-2"
		>
			{{ scheduleTargetNotice$.value.message | translate: (scheduleTargetNotice$.value.args | translateArgs) }}
		</div>
	</div>
	<div
		*ngIf="(!(canAddTime.value$ | async) && (error.manual || error.times) ) || (showContactAdmin.value$ | async)"
		class="inset-x-0 mx-4 my-4"
	>
		<div class="rounded leading-tight px-3 text-[0.825rem] font-semibold text-destructive-foreground bg-black/55">
			<span class="block py-2">{{ 'errors.times.comego.contactAdmin' | translate }}</span>
		</div>
	</div>
</ng-container>
<ng-container *ngIf="getErrorObservable('date') | async as error">
	<ng-container *ngIf="error as br">
		<div class="inset-x-0 mx-4 mb-4">
			<div class="alert alert-danger alert-tight rounded ">
				{{ br.content | translate: (br.args || {} | translateArgs) }}
			</div>
		</div>
	</ng-container>
</ng-container>
<ng-container *ngIf="(overlappingExistingEntryIds$ | async)?.length > 0">
	<div class="inset-x-0 mx-4 mb-4">
		<div class="alert alert-danger alert-tight rounded py-2">{{ 'errors.times.comego.overlap' | translate }}</div>
	</div>
</ng-container>
<mat-dialog-actions class="!box-border !block w-full max-w-full min-w-0 overflow-x-hidden !p-0 !mb-0">
	<div class="box-border grid min-w-0 w-full max-w-full grid-cols-3 gap-10 px-3">
		<div class="flex min-w-0">
			<button
				(click)="cancelAction()"
				[disabled]="isLoading.value$ | async"
				class="!box-border w-full max-w-full min-w-0"
				mat-stroked-button
			>
				<span class="truncate">{{ 'utils.cancel' | translate }}</span>
			</button>
		</div>
		<div class="flex min-w-0 items-center justify-center">
			@if (pendingProjectionFix) {
			<button
				(click)="saveWithViolation()"
				[disabled]="isLoading.value$ | async"
				[matTooltip]="'comego.stopWithoutCorrectionTooltip' | translate"
				class="!box-border w-full max-w-full min-w-0"
				color="warn"
				mat-stroked-button
			>
				<span class="truncate">{{ 'comego.stopWithoutCorrection' | translate }}</span>
			</button>
			} @else if (pendingRecordingFix && !(preventDeviatingWorkingHours | async)) {
			<button
				(click)="discardRecording(confirmDeleteDialog)"
				[disabled]="isLoading.value$ | async"
				[matTooltip]="'comego.stopWithoutCorrectionTooltip' | translate"
				class="!box-border w-full max-w-full min-w-0"
				color="warn"
				mat-stroked-button
			>
				<span class="truncate">{{ 'comego.stopWithoutCorrection' | translate }}</span>
			</button>
			}
		</div>
		<div class="flex min-w-0">
			<button
				(click)="submit()"
				[color]="'primary'"
				[disabled]=" (!error.times?.warning && group.invalid || (( error$.value$ | async) && !error$.value?.test) ) && (preventDeviatingWorkingHours | async )|| ((overlappingExistingEntryIds$ | async)?.length > 0)"
				[matTooltip]="'comego.submitFixTooltip' | translate"
				*ngIf="{ times : getErrorObservable('times') | async } as error"
				class="!box-border w-full max-w-full min-w-0 rounded-lg !border-primary !bg-primary !text-primary-foreground"
				mat-stroked-button
			>
				<span class="truncate">{{ 'comego.submitFix' | translate }}</span>
			</button>
		</div>
	</div>
</mat-dialog-actions>

<ng-template
	#recordingText
	let-ref="entry"
>
	<div class="flex flex-col items-start mt-5">
		<div
			[ngClass]="(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]'"
			class="flex items-center justify-start text-red-500 animate-pulse -mt-2"
		>
			<mat-icon class="!text-md !mt-[0.2rem] placeholder:leading-none">fiber_manual_record</mat-icon>
			<span class="text-md font-medium uppercase -ml-[0.6rem]">rec</span>
		</div>
		<div class="flex flex-col items-center mt-1 w-full">
			<mat-divider
				[horizontal]="true"
				class="w-full !border-t-1 !border-neutral-800 dark:!border-neutral-100"
			></mat-divider>
			<ng-container *ngIf="now$ | async as now">
				<span class="text-sm mt-1">
					{{ ref.start | dfnsParse: 'HH:mm' : now | dfnsDifferenceInSeconds: now | parseMsAsDuration: false }}
				</span>
			</ng-container>
		</div>
	</div>
</ng-template>

<ng-template
	#applyToAllDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<mat-dialog-content> <p>{{ 'comego.descriptionToAll' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(true)"
			mat-stroked-button
		>
			{{ 'utils.confirm' | translate }}
		</button>
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>

<ng-template
	#confirmDeleteDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<div
		class="mat-dialog-title-base flex flex-col"
		matDialogTitle
	>
		<h4 class="my-0">{{ 'utils.confirmDeletion' | translate }}</h4>
	</div>
	<mat-dialog-content> <p>{{ 'comego.confrimDeleteRecording' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
		<button
			(click)="ref.close(true)"
			color="warn"
			mat-stroked-button
		>
			{{ 'utils.delete' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>
template>
